import { render, staticRenderFns } from "./portal-about.vue?vue&type=template&id=ae6adff0&scoped=true&"
import script from "./portal-about.vue?vue&type=script&lang=js&"
export * from "./portal-about.vue?vue&type=script&lang=js&"
import style0 from "./portal-about.vue?vue&type=style&index=0&id=ae6adff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6adff0",
  null
  
)

export default component.exports